module.exports = __webpack_public_path__ + "img/cover.76543198.png";